import { Action, Module, VuexModule } from "vuex-module-decorators";
import { News } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class NewsModule extends VuexModule {
    @Action
    [News.showNews](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/news/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [News.listNews](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/news/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [News.saveNews](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/news/insert`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [News.updateNews](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/news/update`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [News.deleteNews](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/news/delete`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [News.uploadNewsBanner](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/news/uploadBanner`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [News.uploadArticleImage](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/news/uploadArticleImage`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [News.removeArticleImage](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/news/removeArticleImage`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}